import React, { useState, useEffect } from "react"

export default function Footer() {
  const [copyrightDate, setCopyrightDate] = useState("2021 - 2022")
  // TODO faire un appel back pour regler le pb cors en http
  // useEffect(() => {
  //   fetch("http://worldclockapi.com/api/json/utc/now")
  //     .then(data => data.json())
  //     .then(d => {
  //       const worldClock = new Date(d.currentDateTime).getFullYear()
  //       if (worldClock === copyrightDate) return
  //       setCopyrightDate(worldClock)
  //     })
  // }, [])

  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
          <strong>L'Ô </strong>
          <span style={{ fontSize: "0.8rem" }}>DU JARDIN</span> by{" "}
          <a href="mailto:contact@csei.me" target="_blank" rel="noreferrer">
            csei.me - web development
          </a>{" "}
          - Copyright © {copyrightDate}.
        </p>
      </div>
    </footer>
  )
}
